export default {
    SET_AUTH_VERIFICATION: (state, data) => {
        state.data = {
            ...state.data,
            ...data,
        };
    },
};
